import store from "../store";

export default class GuidanceRegistry {
    static registry = {
    }

    static register(data) {
        if (!data.type) throw "Guidance type is missing";
        if (GuidanceRegistry.registry[data.type]) throw "Guidance type " + data.type + " already registered";
        var regData = _.clone(data);
        GuidanceRegistry.registry[data.type] = regData;
    }

    static get(type) {
        return GuidanceRegistry.registry[type];
    }

    static clear() {
        GuidanceRegistry.registry = {};
    }

    static highlightRow(component, url, row) {
        component.$router.push(url);
        _.delay(() => { store.dispatch("guidance/clearHighlight"); }, 300);
        _.delay(() => { store.dispatch("guidance/highlightRow", { url: url, row: row }); }, 800);
    }

}

function autoLoadGuidanceRegistry() {
    GuidanceRegistry.clear();

    var requireComponent = require.context('./items');

    requireComponent.keys().forEach(fileName => {
        requireComponent(fileName);
    });
}

autoLoadGuidanceRegistry();



// WEBPACK FOOTER //
// ./src/guidance/guidance-registry.js